import PaymodeModal from './PaymodeModal';

export default PaymodeModal;
